// src/sot/primitives/Snackbar.jsx
import React from "react";

export default function Snackbar({
  open,
  onClose,
  message,
  children,
  duration = 3000,
}) {
  const content = message ?? children;

  React.useEffect(() => {
    if (!open) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [open, onClose, duration]);

  if (!open || !content) return null;

  return (
    <div
      className="
        fixed left-1/2 -translate-x-1/2
        bottom-4 z-[130] max-w-[calc(100vw-32px)]
      "
      role="status"
      aria-live="polite"
    >
      <div
        className="
          flex h-12 min-w-[344px] max-w-[calc(100vw-32px)] items-center gap-3
          rounded-lg pl-4 pr-2
          shadow-[0_12px_24px_rgba(15,23,42,0.18)]
        "
        style={{
          background: "var(--Schemes-Inverse-Surface, #040812)",
          color: "var(--Schemes-Inverse-On-Surface, #F0F1F3)",
        }}
      >
        <div className="min-w-0 flex-1 truncate text-[14px] leading-5">{content}</div>
        <button
          type="button"
          aria-label="Close"
          title="Close"
          onClick={onClose}
          className="ml-auto grid h-10 w-10 shrink-0 place-items-center rounded-full hover:bg-[rgba(255,255,255,0.08)]"
        >
          <span className="inline-block text-[24px] leading-none">×</span>
        </button>
      </div>
    </div>
  );
}
